export const SUCCESS_GET_PRICING_RULES = 'SUCCESS_GET_PRICING_RULES';
export const FAILED_GET_PRICING_RULES = 'FAILED_GET_PRICING_RULES';


// WEBPACK FOOTER //
// src/state/constants/pricingRuleConstants.js